// @core/api/endpoints/billing/create_usage_record.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateUsageRecordRequest,
  CreateUsageRecordResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create usage record
 * Records usage for metered billing. Usage records are aggregated at the end of the billing period and added to the invoice.
 */
export async function CreateUsageRecord(
  data: CreateUsageRecordRequest,
  options?: RequestOptions
): Promise<CreateUsageRecordResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/usage`;
  const requestOptions = options;
  return client.post<CreateUsageRecordResponse>(requestPath, data, requestOptions);
}
